import { IInventoryPage } from '../../inventory-page.interface';


export const SETTINGS_APPEARANCE_PAGE: IInventoryPage = {
	'route': '/settings/appearance',
	'title': 'Appearance',
	'uiReference': [
		'Appearance preferences',
		'Sidebar favorites',
		'Sidebar community',
		'Scale layout',
		'Full screen',
		'Appearance',
		'Choose which interface tools are available in your navigation.',
		'Show favorite shortcuts in the sidebar.',
		'Show favorite shortcuts in the sidebar',
		'Show community shortcuts in the sidebar.',
		'Show community shortcuts in the sidebar',
		'Show the scale layout control in the top navigation.',
		'Show the scale layout control in the top navigation',
		'Show the full screen control in the top navigation.',
		'Show the full screen control in the top navigation'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/setting-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/appearance/appearance.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/appearance/appearance.component.html'
	]
};
